<template>
  <user-center-wrap>
    <div class="recharge">
      <div class="title">充值购买</div>
      <div class="content-a">购买数量：</div>
      <div class="content-b">
        <div
          :class="['item', active == index ? 'active' : '']"
          @click="chooseAmount(index, item.price / 100, item.item_carat)"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="up">
            <div>{{ item.gold / 100 }}克拉</div>
            <img src="./img/diamond.png" alt="" />
          </div>
          <div class="down">¥{{ item.price / 100 }}</div>
          <img class="select" v-show="active == index" src="./img/select.png" alt="" />
        </div>
      </div>
      <!-- <div class="content-c">
        <div>其它金额：</div>
        <input type="text" @focus="focusInputAmount" v-model="inputAmount" placeholder="请输入购买克拉数量" />
      </div> -->
      <div class="content-d">
        <div class="text">支付方式：</div>
        <img src="./img/alipay.png" alt="" />
      </div>
      <div class="content-e">
        <div class="text">应付金额：</div>
        <div class="right">
          <span>{{ payAmount }}</span
          >元
        </div>
      </div>
      <div :class="['content-f', isActivePay ? 'active-pay' : '']" v-show="isActivePay" @click="pay">立即支付</div>
      <div :class="['content-f', isActivePay ? 'active-pay' : '']" v-show="!isActivePay">立即支付</div>
    </div>
    <!-- 支付二维码 -->
    <el-dialog top="30vh" title="" :visible.sync="visible" class="first-gift-dialog" :close-on-click-modal="true">
      <div :class="['qr-pay', isFailure ? 'failure' : '']">
        <div class="close">
          <img src="./img/close.png" @click="visible = false" alt="" />
        </div>
        <div class="content">
          <div class="title">支付宝支付</div>
          <qriously class="qrcode" :value="payUrl" :size="110" :foreground="qrColor" />
          <div class="desc">使用支付宝扫码支付</div>
        </div>
        <div class="foot">{{ payDesc }}</div>
      </div>
    </el-dialog>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../../components/user-center-wrap/user-center-wrap";
import { post } from "../../../util/http";
import { mapState } from "vuex";

export default {
  name: "recharge",
  components: {
    UserCenterWrap,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      list: [],
      active: -1,
      isActivePay: false,
      visible: false,
      payUrl: "http://www.baidu.com",
      isFailure: false,
      qrColor: "black",
      payDesc: "二维码有效时间6分钟",
      timer: null,
      inputAmount: "",
      payAmount: 0,
      productId: "",
    };
  },
  watch: {
    payAmount(n, o) {
      if (n > 0) {
        this.isActivePay = true;
      } else {
        this.isActivePay = false;
      }
    },
    inputAmount(n, o) {
      if (n > 0) {
        this.payAmount = this.inputAmount;
      } else {
        this.payAmount = 0;
      }
    },
  },
  mounted() {
    if (this.active >= 0) {
      this.isActivePay = true;
    }
    this.getPriceList();
  },

  methods: {
    getPriceList() {
      post({
        url: "/api/charge/chargePriceList",
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.list = data.data || [];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    focusInputAmount() {
      this.active = -1;
      this.productId = "";
      if (this.inputAmount == "") {
        this.payAmount = 0;
      }
    },
    chooseAmount(index, amount, productId) {
      this.active = index;
      this.payAmount = amount;
      this.productId = productId;
    },
    popupQrCode() {
      this.visible = true;
      this.isFailure = false;
      this.payDesc = "二维码有效时间6分钟";
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.isFailure = true;
        this.qrColor = "#DBDBDB";
        this.payDesc = "二维码已失效，请重新支付";
      }, 1000 * 60 * 6);
    },
    pay() {
      this.isActivePay = false;
      post({
        url: "/api/payment/applyHsqPayment",
        data: { client_ip: "", pay_type: "DYNAMIC_ALPAY", product_id: this.productId, terminal: 1, user_id: this.userInfo.id },
      })
        .then(({ data }) => {
          if (data.status == 0) {
            this.payUrl = data.data.qrCode;
            if (data.data.qrCode) {
              this.popupQrCode();
            }
            this.isActivePay = true;
            this.$message.success(data.data.respMsg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.recharge {
  padding: 0.28rem 0.44rem;
  color: #333333;
  font-size: 0.16rem;
  font-weight: 400;
  .title {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 500;
    font-size: 0.2rem;
    margin-bottom: 0.32rem;
  }
  .content-a {
    margin-bottom: 0.16rem;
  }
  .content-b {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 1.38rem;
      height: 0.78rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 0.01rem solid #f0f0f0;
      border-radius: 0.05rem;
      margin-right: 0.22rem;
      margin-bottom: 0.16rem;
      position: relative;
      cursor: pointer;
      .up {
        display: flex;
        font-size: 0.18rem;
        font-weight: 500;
        margin-bottom: 0.05rem;
        img {
          width: 0.2rem;
          height: 0.17rem;
          // margin-left: 0.02rem;
        }
      }
      .down {
        font-size: 0.14rem;
        color: #999999;
      }
      .select {
        width: 0.23rem;
        height: 0.23rem;
        position: absolute;
        right: -0.01rem;
        bottom: -0.01rem;
      }
    }
    .active {
      background: linear-gradient(158.56deg, #edfcff 0%, #ffffff 42.59%);
      border: 1px solid #02a8a2;
    }
  }
  .content-c {
    height: 0.8rem;
    display: flex;
    align-items: center;
    input {
      width: 2.8rem;
      height: 0.36rem;
      border: 1px solid #f0f0f0;
      border-radius: 2px;
      text-indent: 0.09rem;
      margin-left: 0.05rem;
      color: #333333;
    }
    input::placeholder {
      color: #999;
      font-size: 0.14rem;
    }
  }
  .content-d {
    display: flex;
    margin-top: 0.1rem;
    .text {
      margin-top: 0.1rem;
      margin-right: 0.05rem;
    }
    img {
      width: 1rem;
    }
  }
  .content-e {
    display: flex;
    margin-top: 0.16rem;
    height: 0.5rem;
    align-items: center;
    .right {
      margin-left: 0.05rem;
      font-weight: 700;
      span {
        font-size: 0.28rem;
        margin-right: 0.05rem;
      }
    }
  }
  .content-f {
    margin: 0.8rem auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.08rem;
    height: 0.37rem;
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    opacity: 0.45;
    border-radius: 0.05rem;
    font-size: 0.14rem;
    color: #ffffff;
    cursor: not-allowed;
  }
  .active-pay {
    opacity: 1;
    cursor: pointer;
  }
}

::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    width: 100%;
    height: 100%;
  }
  .el-dialog {
    width: 3rem;
    height: 2.86rem;
    border-radius: 0.2rem;
  }
}

.qr-pay {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0.2rem;
  background: linear-gradient(158.56deg, #e3faff 0%, #ffffff 42.59%);
  box-shadow: 0px 0px 2.32143px rgba(0, 0, 0, 0.05);
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  background-image: linear-gradient(158.56deg, #e3faff 0%, #ffffff 42.59%), linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
  border: 0.04rem solid transparent;
}

.close {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.16rem;
  margin-right: 0.16rem;
  img {
    width: 0.16rem;
    height: 0.16rem;
    cursor: pointer;
  }
}
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0.16rem;
  color: #333333;
  .title {
    font-weight: 600;
    font-size: 0.24rem;
    text-align: center;
  }
  .qrcode {
    border: 0.01rem solid #02a8a2;
    // padding: 0.08rem;
  }
  .desc {
    font-weight: 400;
    font-size: 0.18rem;
  }
}
.foot {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.4rem;
  background: linear-gradient(90deg, rgba(41, 241, 156, 0.1) 0%, rgba(2, 161, 249, 0.1) 100%);
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.05);
  font-size: 0.16rem;
  color: #02a8a2;
}
.failure {
  background-image: linear-gradient(158.56deg, #ffede3 0%, #ffffff 42.59%), linear-gradient(90deg, #ffd0b5 0%, #ff8a49 100%);
  .qrcode {
    border: 0.01rem solid #dbdbdb;
  }
  .desc {
    color: #666666;
  }
  .foot {
    background: linear-gradient(108.02deg, rgba(226, 228, 228, 0.5) 0%, rgba(211, 214, 218, 0.5) 62.15%);
    color: #999999;
  }
}
</style>
